import type { default as Option, CoreOption } from "../store/schema/Option";
import type OptionComponentSettings from "../store/schema/OptionComponentSettings";

export function createOption(coreOption: CoreOption, fullOptionFormSettings?: OptionComponentSettings): Option {
    return { ...coreOption, fullOptionFormSettings };
}
